import { schema } from 'normalizr';

export const materialClassSchema = new schema.Entity('materialClasses');
export const materialFamilySchema = new schema.Entity('materialFamilies');
export const materialSchema = new schema.Entity('materials');
export const supplierMaterialSchema = new schema.Entity('supplierMaterials');
